import { Raffle } from '@/app/entities/Raffle'
import { fetchStringToFile } from '@/app/utils/fetchStringToFile'
import { addDays, isValid } from 'date-fns'
import { RaffleFormValues } from './hooks/useRaffleForm'

export const raffleHasEnded = (raffle: Raffle) => {
  return new Date(raffle?.endDate) < new Date()
}

export const getRaffleFormDefaultValues = async (
  raffle: Raffle,
): Promise<RaffleFormValues> => {
  const galleryPromises = raffle?.gallery?.map((image) => {
    return fetchStringToFile(image, 'image/png')
  })

  const prizes = raffle.prizes.map((prize) => ({
    name: prize.name,
  }))

  return {
    ...raffle,
    ...parseRaffleDates(raffle),
    identificadorSorteioStart: '',
    banner: await fetchStringToFile(raffle?.banner, 'image/png'),
    gallery: await Promise.all(galleryPromises),
    couponValue: +(raffle.couponValue / 100).toFixed(2),
    prizes,
  }
}

const parseRaffleDates = (raffle: Raffle) => {
  let endDate = new Date(raffle?.endDate)
  let startDate = new Date(raffle?.startDate)
  let resultDate = new Date(raffle?.resultDate)
  if (!isValid(startDate)) startDate = new Date()
  if (!isValid(endDate)) endDate = addDays(new Date(), 1)
  if (!isValid(resultDate)) resultDate = addDays(new Date(), 2)
  return { endDate, startDate, resultDate }
}
